import chair from './chair.jpg'
import cobra from './cobra.jpg'
import dog from './dog.jpg'
import Vrikshasana from './tree.jpg'
import VirabhadrasanaII from './warrior.jpg'
import Trikonasana from './traingle.jpg'
import shoulderstand from './shoulderstand.jpg'

export const poseImages = {
    Vrikshasana: Vrikshasana,
    Bhujangasana : cobra,
    "Adho mukha Svanasana": dog,
    "Virabhadrasana II": VirabhadrasanaII,
    Utkatasana: chair,
    Trikonasana: Trikonasana,
    Sarvangasana : shoulderstand
} 



 